module.exports = __webpack_public_path__ + "img/giftBox_empty.2cb4589e.svg";